import styled from "styled-components";
import {Link, useParams} from "react-router-dom";
import axios from "axios";
import {useEffect, useState} from "react";
import {Sidebar} from "../../../components/Sidebar";
import {NavHeader} from "../../../components/NavHeader";
import OrderDetails from "../../../components/OrderDetails";
import Spinner from "../../../components/Spinner";
import Feedback from "../../../components/Feedback";
import colours from "../../../styles/appColours";
import {BsPerson} from "react-icons/bs";
import {Capitalize, getDate} from "../../../utils/utils";
import AppLayout from "../../../layouts/AdminLayout";

import {EmptyState} from "../../../components/EmptyState";
import {StatusCard} from "../../../components/StatusCard";
import {TableData} from "../../../components/TableData";
import ExportOrdersComponent from "./ExportData";
import GoBackButton from "../../../components/GoBackButton";
import {getStatusType} from "../../../utils/status";
import DisplayField from "../../../components/DisplayField";
import {useRoles} from "../../../hooks/useRoles";

export const SingleCustomer = () => {
  const {id} = useParams();
  const {scope} = useRoles();
  const [order, setOrder] = useState<any>([]);
  const [totalOrders, setTotalOrders] = useState<any>(0);
  const [orderIds, setOrderIds] = useState([]);
  const [customer, setCustomer] = useState<any>({});
  const [updateStatus, setUpdateStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState({
    update: false,
    search: false,
    data: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [open, setOpen] = useState(false);
  const Baseurl = process.env.REACT_APP_BASEURL;
  const getToken: any = localStorage.getItem("eftd-admin-token");
  const tokenObject: any = JSON.parse(getToken);
  const getUserRole: any = tokenObject?.data?.user?.role;
  const token = tokenObject?.data?.data?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    setIsLoading(true);
    setLoading({...loading, data: true});
    axios
      .get(
        `${Baseurl}/api/admin/orders?limit=10&page=${currentPage}&filter=userId:${id}`,
        config
      )
      .then((res) => {
        setLoading({...loading, data: false});
        setIsLoading(false);
        setOrder(res?.data?.data?.items);
        setTotalOrders(res?.data?.data?.meta?.total);
      })
      .catch((err) => {
        setLoading({...loading, data: false});
      });
  }, [id, currentPage]);

  useEffect(() => {
    axios
      .get(`${Baseurl}/api/admin/customers/getcustomers/${id}`, config)
      .then((res) => {
        setCustomer(res?.data?.data);
      })
      .catch((err) => {});
  }, [id]);

  const userAccess = (userPermission: string) => {
    let status;
    if (userPermission === "manager") {
      status = [
        {
          value: "cancelled",
          name: "Cancelled",
        },
        {
          value: "delivered",
          name: "Delivered",
        },
        {
          value: "in-transit",
          name: "In Transit",
        },
        {
          value: "pickup",
          name: "Picked Up",
        },
        {
          value: "processing",
          name: "Processing",
        },
      ];
    } else {
      status = [
        {
          value: "cancelled",
          name: "Cancelled",
        },
        {
          value: "in-transit",
          name: "In Transit",
        },
      ];
    }
    return status;
  };

  const updateOrdersFunction = async () => {
    if (orderIds.length < 1) {
      throw new Error("Error");
    } else {
      const data: any = {orderStatus: updateStatus, orderIds};
      const response = await axios.patch(
        `${Baseurl}/api/admin/orders/multiple-orders`,
        data,
        config
      );
      return response;
    }
  };

  const updateOrders = async () => {
    try {
      setLoading({...loading, update: true});
      await updateOrdersFunction();
      setFeedback("success");
      setOpen(true);
      setLoading({...loading, update: false});
    } catch (err) {
      setLoading({...loading, update: false});
      setFeedback("failed");
      setOpen(true);
    }
  };

  const STATUS_TYPES = {
    PENDING: {title: "Pending", type: "pending"},
    COMPLETED: {title: "Completed", type: "completed"},
    CANCELLED: {title: "Cancelled", type: "cancelled"},
    PICKED_UP: {title: "Picked Up", type: "completed"},
    PROCESSING: {title: "Processing", type: "pending"},
    PICKED_UP_SCHEDULED: {title: "Pickup Scheduled", type: "pending"},
  };

  const TABLE_HEAD = [
    "Date",
    "Order ID",
    "Source",
    "Delivery Category",
    "Price",
    "Status",
    "Action",
  ];

  // const [count, setCount] = useState(0);
  // setCount(count + 1);

  const Capitalize = (str: string) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const defaultAvatar =
    "https://via.placeholder.com/150/007bff/dddddd?text=User";
  const avatarSrc = customer?.avatarURL || defaultAvatar;

  return (
    <AppLayout>
      {/* Go Back Button */}
      <div className="p-5">
        <GoBackButton />
      </div>

      <div className="mx-5 bg-gray-50 p-8 rounded-[20px] border border-gray-200">
        <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-8 mb-10">
          <div className="flex-shrink-0 mb-6 md:mb-0">
            {!customer?.avatarURL ? (
              <BsPerson className="text-4xl text-gray-500" />
            ) : (
              <img
                src={avatarSrc}
                className="w-18 h-18 rounded-full object-cover border-4 border-green-500 shadow-xl"
              />
            )}
          </div>
          <div className="text-center md:text-left flex-grow">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-2">
              {Capitalize(customer?.businessName || "Business Profile")}
            </h2>

            <p className="text-xl text-gray-700 mb-4">
              {customer?.accountType || "N/A"}
            </p>
            {/* {(customer?.firstName || customer?.lastName) && (
              <p className="text-xl text-gray-700 mb-4">
                <span className="font-semibold">Personal Account:</span> {Capitalize(customer?.firstName || "")} {Capitalize(customer?.lastName || "")}
              </p>
            )} */}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact Information Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 transition-all duration-200 hover:shadow-md">
            <h3 className="text-2xl font-semibold text-black-700 mb-5 pb-3 border-b border-blue-100">
              Contact Information
            </h3>
            <div className="space-y-4">
              <DisplayField
                label="Email Address"
                value={customer?.email}
                icon="📧"
              />
              <DisplayField
                label="Phone Number"
                value={customer?.phoneNumber}
                icon="📱"
              />
              <DisplayField
                label="Address"
                value={customer?.address || "N/A"}
                icon="📍"
              />
            </div>
          </div>

          {/* Business & Contact Person Details Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 transition-all duration-200 hover:shadow-md">
            {customer?.accountType != "INDIVIDUAL" ? (
              <>
                <h3 className="text-2xl font-semibold text-black-700 mb-5 pb-3 border-b border-blue-100">
                  Business & Key Contacts
                </h3>
                <div className="space-y-4">
                  {customer?.businessName && (
                    <DisplayField
                      label="Registered Business Name"
                      value={Capitalize(customer.businessName)}
                      icon="🏢"
                    />
                  )}
                  {customer?.cac && (
                    <>
                      <DisplayField
                        label="CAC / RC Number"
                        value={customer.cac}
                        icon="📄"
                      />
                      {customer?.cacDocFileURL && (
                        <div className="ml-9 -mt-2">
                          {" "}
                          {/* Adjust margin to align with icon */}
                          <a
                            href={customer.cacDocFileURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center text-sm text-indigo-600 font-medium hover:underline"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
                              <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
                            </svg>
                            View CAC Document
                          </a>
                        </div>
                      )}
                    </>
                  )}

                  <h4 className="text-xl font-medium text-gray-700 mt-6 pt-4 border-t border-gray-200">
                    Contact Person Details
                  </h4>
                  <DisplayField
                    label="Full Name"
                    value={customer?.businessContactInfo?.fullName || "N/A"}
                    icon="👤"
                  />
                  <DisplayField
                    label="Phone Number"
                    value={customer?.businessContactInfo?.phoneNumber || "N/A"}
                    icon="📞"
                  />
                </div>
              </>
            ) : (
              <>
                <h3 className="text-2xl font-semibold text-black-700 mb-5 pb-3 border-b border-blue-100">
                  Personal Details
                </h3>
                <div className="space-y-4">
                  <DisplayField
                    label="Full Name"
                    value={`${Capitalize(
                      customer?.firstName || ""
                    )} ${Capitalize(customer?.lastName || "")}`}
                    icon="👤"
                  />
                  <DisplayField
                    label="Phone Number"
                    value={customer?.phoneNumber || "N/A"}
                    icon="📞"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Customer Activity Section */}
        {/* <div className="w-full border border-gray-300 rounded p-5 mt-4 space-y-2">
          <h3 className="text-sm font-semibold text-orange-500">
            Customer Activity
          </h3>

          <p className="text-sm text-gray-700">
            Subscription Plan: <strong>{customer?.subscription?.name}</strong>
          </p>

          <p className="text-sm text-gray-700">
            Subscription Expiry Date:{" "}
            {customer?.subscription?.subscriptionEnd
              ? getDate(customer?.subscription?.subscriptionEnd)
              : "N/A"}
          </p>

          <p className="text-sm text-gray-700">
            Total Orders: <strong>{totalOrders || 0}</strong>
          </p>
        </div> */}
      </div>

      {order?.length > 0 && scope === "write" && (
        <div className="p-5 my-5 flex justify-between">
          <h2 className="text-2xl font-semibold text-gray-900">Orders</h2>
          <ExportOrdersComponent userId={customer?.id} />
        </div>
      )}

      {/* <Updateorder>
          <div>
            <label htmlFor="">Status</label>
            <select onChange={(e) => setUpdateStatus(e.target.value)}>
              {userAccess(getUserRole).map((status) => (
                <option value={status.value}>{status.name} </option>
              ))}
            </select>
          </div>
          <button onClick={updateOrders}>
            {loading.update ? <Spinner /> : "Update order"}
          </button>
        </Updateorder> */}

      {/* {order?.length > 0 ? (
        <HistoryList>
          {loading.data ? (
            <Spinner componentlevel={true} />
          ) : (
            <OrderDetails
              data={order}
              pageLimit={undefined}
              dataLimit={5}
              orderIds={setOrderIds}
              pageDetails={order?.paging}
              currentPageNo={setCurrentPage}
              pageNum={currentPage}
            />
          )}
        </HistoryList>
        ) : (
          <div className="mx-5 p-20 border border-gray-300 text-center rounded">No orders at the moment.</div>
        )} */}

      {isLoading ? (
        <div className="py-10 text-center text-gray-400 text-sm">
          Loading...
        </div>
      ) : order?.length > 0 ? (
        <div className="px-5 overflow-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th
                    key={head}
                    className="p-3 text-xs font-medium text-gray-500"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {order.map((order: any) => {
                const status = getStatusType(order.orderStatus);
                return (
                  <tr
                    key={order.id}
                    className="border-b border-gray-100 hover:bg-gray-100 transition-colors"
                  >
                    <TableData
                      content={new Date(order.createdAt).toLocaleDateString()}
                    />
                    <TableData content={order.orderId} />
                    <TableData content={order.source || "NILL"} />
                    <TableData content={order.deliveryType} />
                    {/* <TableData content={`₦${order.estimatedCost}`} /> */}
                    <TableData
                      content={`₦${parseInt(
                        order.estimatedCost
                      ).toLocaleString()}`}
                    />
                    <td className="p-3">
                      <StatusCard title={status.title} type={status.type} />
                    </td>
                    <td className="p-3">
                      <Link
                        to={`/orders/${order.id}`}
                        className="text-sm font-semibold text-orange-500 hover:text-orange-600"
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="px-5 py-14">
          <EmptyState type="order" text="No Orders Yet" />
        </div>
      )}

      <Feedback feedback={feedback} open={open} close={() => setOpen(false)} />
    </AppLayout>
  );
};

const Updateorder = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin: 20px;
  gap: 10px;
  width: 100%;

  > div {
    display: flex;
    flex-direction: column;

    > select {
      background: #ffffff;
      border: 1px solid #333333;
      border-radius: 10px;
      padding: 10px 0px;
      width: 280px;
      cursor: pointer;
    }
    > label {
      padding-left: 20px;
    }
  }
  > button {
    background: #333333;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 40px;
    border: none;
    color: #ffffff;
    cursor: pointer;
  }
`;

const HistoryList = styled.section`
  background-color: #fafafa;
  width: 100%;
  @media (max-width: 425px) {
    width: 100%;
    background-color: #ffffff;
  }
`;
const UserProfile = styled.main`
  background-color: #ffffff;
  width: 60%;
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  border-radius: 16px;
  padding: 20px 0px 60px 0px;

  @media (max-width: 600px) {
    width: 95%;
  }
`;
const UserImage = styled.div`
  height: 88px;
  width: 88px;
  background-color: #f2efef;
  border-radius: 50%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const UserName = styled.h2`
  color: #333333;
  font-size: 16px;
`;

const Active = styled.h2`
  font-size: 16px;
  padding: 5px 20px;
  border-radius: 5px;
`;

const UserRole = styled.p`
  display: flex;
  align-items: center;
  gap: 3px;
`;
const UserDatas = styled.div`
  display: flex;
  padding: 30px;
  flex-direction: column;
  width: 80%;
  border: 0.5px solid #13131a;
  text-align: left;
  border-radius: 5px;
  margin-top: 20px;

  label {
    color: #333333;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    width: 95%;
  }
`;
const UserInfo = styled.input`
  padding: 5px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  border-radius: 5px;
  border: 0.5px solid #13131a;
  padding: 10px;
`;

const Copyable = styled.div`
  padding: 5px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  border-radius: 5px;
  border: 0.5px solid #13131a;
  background: #f2f2f2;
  padding: 10px;
`;
const Title = styled.h2`
  font-family: "Red Hat Display";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: left;

  /* New Orange */

  color: #f66d00;
`;

const Text = styled.p`
  text-align: left;
  /* width: 80%; */
  margin: 0 auto;
  font-weight: 300;
  color: #4d4949;
`;
const NewText = styled(Text)`
  background-color: #ffffff;
  height: 50px;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
`;

const Change = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin-bottom: 30px;
`;

const Input = styled.input`
  display: block;
  height: 53px;
  width: 500px;
  border-radius: 8px;
  background-color: #fafafa;
  outline: none;
  border: none;
  padding-left: 20px;
  @media (max-width: 1024px) {
    width: 30vw;
  }
  @media (max-width: 600px) {
    width: 90vw;
    /* margin-bottom: 10px; */
  }
`;
const InputSection = styled.div`
  padding-top: 20px;
  /* height: 50%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
`;

const Span = styled.span`
  font-weight: 400;
  width: 200px;
  display: inline-block;
`;
